import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { LayoutDashboard, Calendar, Users, BookOpen, Bell, Image as ImgIcon, Settings, LogOut, ExternalLink, UserPlus, ClipboardCheck, FileText } from "lucide-react";

const links = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/eventos", label: "Eventos", icon: Calendar },
  { to: "/admin/participantes", label: "Inscrições", icon: Users },
  { to: "/admin/jovens", label: "Jovens", icon: UserPlus },
  { to: "/admin/presenca", label: "Presença", icon: ClipboardCheck },
  { to: "/admin/relatorios", label: "Relatórios", icon: FileText },
  { to: "/admin/devocionais", label: "Devocionais", icon: BookOpen },
  { to: "/admin/avisos", label: "Avisos", icon: Bell },
  { to: "/admin/galeria", label: "Galeria", icon: ImgIcon },
  { to: "/admin/configuracoes", label: "Config", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-[#000000] text-white relative">
      <div className="ambient-bg" />
      <div className="relative z-10 flex flex-col lg:flex-row">
        <aside className="lg:w-60 lg:min-h-screen border-b lg:border-b-0 lg:border-r border-blue-500/15 bg-[#000000]/80 backdrop-blur-xl">
          <div className="p-5 border-b border-blue-500/10">
            <Logo size="sm" onClick={() => nav("/")} />
            <div className="label mt-3">Painel Admin</div>
          </div>
          <nav className="p-3 flex lg:flex-col gap-1 overflow-x-auto lg:overflow-visible">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.end}
                       data-testid={`admin-nav-${l.label.toLowerCase()}`}
                       className={({ isActive }) =>
                         `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm whitespace-nowrap ${isActive ? "bg-blue-500/15 text-blue-300 border border-blue-500/30" : "text-slate-300 hover:bg-white/5"}`}>
                <l.icon size={16} /> {l.label}
              </NavLink>
            ))}
          </nav>
          <div className="p-3 lg:absolute lg:bottom-0 lg:left-0 lg:w-60 border-t border-blue-500/10 space-y-1">
            <div className="px-3 py-2 text-xs text-slate-400 truncate">{user?.email}</div>
            <a href="/" className="flex items-center gap-3 px-3 py-2 text-xs text-slate-400 hover:text-blue-400"><ExternalLink size={14}/> Ver site</a>
            <button data-testid="admin-logout-btn" onClick={() => { logout(); nav("/"); }} className="w-full flex items-center gap-3 px-3 py-2 text-xs text-slate-400 hover:text-red-400"><LogOut size={14}/> Sair</button>
          </div>
        </aside>
        <main className="flex-1 p-4 sm:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
